export default __webpack_public_path__ + "static/media/login_img.48bd1b5e.png";